var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtlLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 209.45 212.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4d4b4c;}.cls-2{fill:#3e3c3d;}.cls-3{fill:#3d3a3c;}.cls-4{fill:#7ec042;}.cls-5{fill:#5d5d5e;}.cls-6{fill:#696a6c;}.cls-7{fill:#4f4d4f;}.cls-8{fill:#272425;}.cls-9{fill:#242021;}.cls-10{fill:#424142;}.cls-11{fill:#4c4b4b;}.cls-12{fill:#636364;}.cls-13{fill:#3c393a;}.cls-14{fill:#535254;}.cls-15{fill:#4c4b4c;}.cls-16{fill:#494849;}.cls-17{fill:#2c2929;}.cls-18{fill:#606062;}.cls-19{fill:#3d3b3c;}.cls-20{fill:#eb2728;}.cls-21{fill:#585758;}.cls-22{fill:#383636;}.cls-23{fill:#3b393a;}.cls-24{fill:#333031;}.cls-25{fill:#656566;}.cls-26{fill:#646466;}.cls-27{fill:#282425;}.cls-28{fill:#f26e24;}.cls-29{fill:#6a6b6c;}.cls-30{fill:#2c292a;}.cls-31{fill:#2b2828;}.cls-32{fill:#363334;}.cls-33{fill:#6b6c6e;}.cls-34{fill:#403e3e;}.cls-35{fill:#7fc142;}.cls-36{fill:#4b494a;}.cls-37{fill:#2ac0d7;}.cls-38{fill:#2ec0d6;}.cls-39{fill:#35c0d1;}.cls-40{fill:#474647;}.cls-41{fill:#616162;}.cls-42{fill:#464445;}.cls-43{fill:#5b5b5c;}.cls-44{fill:#006e58;}.cls-45{fill:#5a595a;}.cls-46{fill:#535253;}.cls-47{fill:#363435;}.cls-48{fill:#a7ce39;}.cls-49{fill:#424041;}.cls-50{fill:#383536;}.cls-51{fill:#504e4f;}.cls-52{fill:#626263;}.cls-53{fill:#3b3939;}.cls-54{fill:#656667;}.cls-55{clip-path:url(#clippath-1);}.cls-56{fill:#5f5f60;}.cls-57{fill:#373435;}.cls-58{fill:#555455;}.cls-59{fill:#2d2a2b;}.cls-60{fill:#3a3738;}.cls-61{fill:#2b2829;}.cls-62{fill:#353233;}.cls-63{fill:#403e3f;}.cls-64{fill:#525152;}.cls-65{fill:#676769;}.cls-66{fill:#75308e;}.cls-67{fill:#262323;}.cls-68{fill:#4e4d4d;}.cls-69{fill:#302d2e;}.cls-70{fill:#666668;}.cls-71{fill:#626364;}.cls-72{fill:#343132;}.cls-73{fill:#3d3c3c;}.cls-74{fill:#5c5b5c;}.cls-75{fill:#252223;}.cls-76{fill:#514f50;}.cls-77{fill:#6c6d6f;}.cls-78{fill:#3f3c3d;}.cls-79{fill:#494748;}.cls-80{fill:#3f3d3e;}.cls-81{fill:#545354;}.cls-82{fill:#636365;}.cls-83{fill:#f8c316;}.cls-84{fill:#565556;}.cls-85{fill:#6c6c6e;}.cls-86{fill:#333131;}.cls-87{fill:#0baa4b;}.cls-88{fill:#2a2728;}.cls-89{fill:#464546;}.cls-90{fill:#fcc616;}.cls-91{fill:#504f50;}.cls-92{fill:#312e2f;}.cls-93{fill:#6d6f70;}.cls-94{fill:#007055;}.cls-95{fill:#606061;}.cls-96{fill:#262223;}.cls-97{fill:#626163;}.cls-98{fill:#6a6a6c;}.cls-99{clip-path:url(#clippath);}.cls-100{fill:#4e4d4e;}.cls-101{fill:#68696a;}.cls-102{fill:#5b5a5b;}.cls-103{fill:none;}.cls-104{fill:#59585a;}.cls-105{fill:#5d5c5e;}.cls-106{fill:#00705a;}.cls-107{fill:#535152;}.cls-108{fill:#4a4849;}.cls-109{fill:#434142;}.cls-110{fill:#68686a;}.cls-111{fill:#676768;}.cls-112{fill:#2f2c2d;}.cls-113{fill:#292526;}.cls-114{fill:#2a2727;}.cls-115{fill:#4e4c4d;}.cls-116{fill:#3a3839;}.cls-117{fill:#292627;}.cls-118{fill:#221f1f;}.cls-119{fill:#595859;}.cls-120{fill:#656567;}.cls-121{fill:#383637;}.cls-122{fill:#252122;}.cls-123{fill:#444243;}.cls-124{fill:#454344;}.cls-125{fill:#565657;}.cls-126{fill:#515051;}.cls-127{fill:#68696b;}.cls-128{fill:#3c3a3b;}.cls-129{fill:#272324;}.cls-130{fill:#5a595b;}.cls-131{fill:#444344;}.cls-132{fill:#6a6c6d;}.cls-133{fill:#393637;}.cls-134{fill:#06a94b;}.cls-135{fill:#413f40;}.cls-136{fill:#6d6e70;}.cls-137{fill:#5c5c5d;}.cls-138{fill:#5e5e5f;}.cls-139{fill:#575658;}.cls-140{fill:#2e2b2c;}.cls-141{fill:#444143;}.cls-142{fill:#4b4a4b;}.cls-143{fill:#322f30;}.cls-144{fill:#474546;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "m201.56,106.24c0,56-43.35,101.4-96.83,101.4S7.89,162.24,7.89,106.24,51.25,4.84,104.73,4.84s96.83,45.4,96.83,101.4Zm-96.83-59.69c-24.84,0-44.97,26.73-44.97,59.69s20.13,59.69,44.97,59.69,44.97-26.73,44.97-59.69-20.13-59.69-44.97-59.69Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "m201.56,106.24c0,56-43.35,101.4-96.83,101.4S7.89,162.24,7.89,106.24,51.25,4.84,104.73,4.84s96.83,45.4,96.83,101.4Zm-96.83-59.69c-24.84,0-44.97,26.73-44.97,59.69s20.13,59.69,44.97,59.69,44.97-26.73,44.97-59.69-20.13-59.69-44.97-59.69Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-99"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "60.48 46.55 59.76 47.8 59.76 46.55 60.48 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "61.21 46.55 59.76 49.07 59.76 47.8 60.48 46.55 61.21 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "61.95 46.55 59.76 50.34 59.76 49.07 61.21 46.55 61.95 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "62.68 46.55 59.76 51.61 59.76 50.34 61.95 46.55 62.68 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "63.41 46.55 59.76 52.88 59.76 51.61 62.68 46.55 63.41 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "64.15 46.55 59.76 54.15 59.76 52.88 63.41 46.55 64.15 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "64.88 46.55 59.76 55.42 59.76 54.15 64.15 46.55 64.88 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "65.61 46.55 59.76 56.69 59.76 55.42 64.88 46.55 65.61 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "66.35 46.55 59.76 57.96 59.76 56.69 65.61 46.55 66.35 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-126",
    points: "67.08 46.55 59.76 59.23 59.76 57.96 66.35 46.55 67.08 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-126",
    points: "67.81 46.55 59.76 60.5 59.76 59.23 67.08 46.55 67.81 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "68.54 46.55 59.76 61.77 59.76 60.5 67.81 46.55 68.54 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "69.28 46.55 59.76 63.03 59.76 61.77 68.54 46.55 69.28 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "70.01 46.55 59.76 64.3 59.76 63.03 69.28 46.55 70.01 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "70.74 46.55 59.76 65.57 59.76 64.3 70.01 46.55 70.74 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "71.48 46.55 59.76 66.84 59.76 65.57 70.74 46.55 71.48 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "72.21 46.55 59.76 68.11 59.76 66.84 71.48 46.55 72.21 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "72.94 46.55 59.76 69.38 59.76 68.11 72.21 46.55 72.94 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "73.68 46.55 59.76 70.65 59.76 69.38 72.94 46.55 73.68 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "74.41 46.55 59.76 71.92 59.76 70.65 73.68 46.55 74.41 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "75.14 46.55 59.76 73.19 59.76 71.92 74.41 46.55 75.14 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-142",
    points: "75.88 46.55 59.76 74.46 59.76 73.19 75.14 46.55 75.88 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "76.61 46.55 59.76 75.73 59.76 74.46 75.88 46.55 76.61 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "77.34 46.55 59.76 77 59.76 75.73 76.61 46.55 77.34 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "78.08 46.55 59.76 78.27 59.76 77 77.34 46.55 78.08 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "78.81 46.55 59.76 79.54 59.76 78.27 78.08 46.55 78.81 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "79.54 46.55 59.76 80.81 59.76 79.54 78.81 46.55 79.54 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "80.28 46.55 59.76 82.08 59.76 80.81 79.54 46.55 80.28 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "81.01 46.55 59.76 83.35 59.76 82.08 80.28 46.55 81.01 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-144",
    points: "81.74 46.55 59.76 84.62 59.76 83.35 81.01 46.55 81.74 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "82.48 46.55 59.76 85.89 59.76 84.62 81.74 46.55 82.48 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "83.21 46.55 59.76 87.16 59.76 85.89 82.48 46.55 83.21 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "83.94 46.55 59.76 88.43 59.76 87.16 83.21 46.55 83.94 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "84.68 46.55 59.76 89.7 59.76 88.43 83.94 46.55 84.68 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "85.41 46.55 59.76 90.97 59.76 89.7 84.68 46.55 85.41 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "86.14 46.55 59.76 92.24 59.76 90.97 85.41 46.55 86.14 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "86.87 46.55 59.76 93.51 59.76 92.24 86.14 46.55 86.87 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "87.61 46.55 59.76 94.78 59.76 93.51 86.87 46.55 87.61 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "88.34 46.55 59.76 96.05 59.76 94.78 87.61 46.55 88.34 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "89.07 46.55 59.76 97.32 59.76 96.05 88.34 46.55 89.07 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "89.81 46.55 59.76 98.59 59.76 97.32 89.07 46.55 89.81 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "90.54 46.55 59.76 99.86 59.76 98.59 89.81 46.55 90.54 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "91.27 46.55 59.76 101.13 59.76 99.86 90.54 46.55 91.27 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "92.01 46.55 59.76 102.4 59.76 101.13 91.27 46.55 92.01 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "92.74 46.55 59.76 103.67 59.76 102.4 92.01 46.55 92.74 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "93.47 46.55 59.76 104.94 59.76 103.67 92.74 46.55 93.47 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "94.21 46.55 59.76 106.21 59.76 104.94 93.47 46.55 94.21 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "94.94 46.55 59.76 107.48 59.76 106.21 94.21 46.55 94.94 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "95.67 46.55 59.76 108.75 59.76 107.48 94.94 46.55 95.67 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "96.41 46.55 59.76 110.02 59.76 108.75 95.67 46.55 96.41 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "97.14 46.55 59.76 111.29 59.76 110.02 96.41 46.55 97.14 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "97.87 46.55 59.76 112.56 59.76 111.29 97.14 46.55 97.87 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "98.61 46.55 59.76 113.83 59.76 112.56 97.87 46.55 98.61 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "99.34 46.55 59.76 115.1 59.76 113.83 98.61 46.55 99.34 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "100.07 46.55 59.76 116.37 59.76 115.1 99.34 46.55 100.07 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-116",
    points: "100.81 46.55 59.76 117.64 59.76 116.37 100.07 46.55 100.81 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "101.54 46.55 59.76 118.91 59.76 117.64 100.81 46.55 101.54 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "102.27 46.55 59.76 120.18 59.76 118.91 101.54 46.55 102.27 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "103.01 46.55 59.76 121.45 59.76 120.18 102.27 46.55 103.01 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-121",
    points: "103.74 46.55 59.76 122.72 59.76 121.45 103.01 46.55 103.74 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "104.47 46.55 59.76 123.99 59.76 122.72 103.74 46.55 104.47 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "105.2 46.55 59.76 125.26 59.76 123.99 104.47 46.55 105.2 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "105.94 46.55 59.76 126.53 59.76 125.26 105.2 46.55 105.94 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "106.67 46.55 59.76 127.8 59.76 126.53 105.94 46.55 106.67 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "107.4 46.55 59.76 129.07 59.76 127.8 106.67 46.55 107.4 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "108.14 46.55 59.76 130.34 59.76 129.07 107.4 46.55 108.14 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "108.87 46.55 59.76 131.61 59.76 130.34 108.14 46.55 108.87 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "109.6 46.55 59.76 132.88 59.76 131.61 108.87 46.55 109.6 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "110.34 46.55 59.76 134.15 59.76 132.88 109.6 46.55 110.34 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "111.07 46.55 59.76 135.42 59.76 134.15 110.34 46.55 111.07 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "111.8 46.55 59.76 136.69 59.76 135.42 111.07 46.55 111.8 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "112.54 46.55 59.76 137.96 59.76 136.69 111.8 46.55 112.54 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-143",
    points: "113.27 46.55 59.76 139.23 59.76 137.96 112.54 46.55 113.27 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-143",
    points: "114 46.55 59.76 140.5 59.76 139.23 113.27 46.55 114 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "114.74 46.55 59.76 141.77 59.76 140.5 114 46.55 114.74 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "115.47 46.55 59.76 143.04 59.76 141.77 114.74 46.55 115.47 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "116.2 46.55 59.76 144.31 59.76 143.04 115.47 46.55 116.2 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "116.94 46.55 59.76 145.58 59.76 144.31 116.2 46.55 116.94 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "117.67 46.55 59.76 146.85 59.76 145.58 116.94 46.55 117.67 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "118.4 46.55 59.76 148.12 59.76 146.85 117.67 46.55 118.4 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "119.14 46.55 59.76 149.39 59.76 148.12 118.4 46.55 119.14 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "119.87 46.55 59.76 150.66 59.76 149.39 119.14 46.55 119.87 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "120.6 46.55 59.76 151.93 59.76 150.66 119.87 46.55 120.6 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "121.34 46.55 59.76 153.2 59.76 151.93 120.6 46.55 121.34 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "122.07 46.55 59.76 154.47 59.76 153.2 121.34 46.55 122.07 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "122.8 46.55 59.76 155.74 59.76 154.47 122.07 46.55 122.8 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "123.54 46.55 60.13 156.36 59.76 156.14 59.76 155.74 122.8 46.55 123.54 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "124.27 46.55 60.68 156.68 60.13 156.36 123.54 46.55 124.27 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "125 46.55 61.23 156.99 60.68 156.68 124.27 46.55 125 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-114",
    points: "125.73 46.55 61.78 157.31 61.23 156.99 125 46.55 125.73 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-117",
    points: "126.47 46.55 62.33 157.63 61.78 157.31 125.73 46.55 126.47 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "127.2 46.55 62.88 157.95 62.33 157.63 126.47 46.55 127.2 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "127.93 46.55 63.43 158.26 62.88 157.95 127.2 46.55 127.93 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "128.67 46.55 63.98 158.58 63.43 158.26 127.93 46.55 128.67 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "129.4 46.55 64.53 158.9 63.98 158.58 128.67 46.55 129.4 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "130.13 46.55 65.08 159.22 64.53 158.9 129.4 46.55 130.13 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "130.87 46.55 65.63 159.53 65.08 159.22 130.13 46.55 130.87 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "131.6 46.55 66.18 159.85 65.63 159.53 130.87 46.55 131.6 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "132.33 46.55 66.73 160.17 66.18 159.85 131.6 46.55 132.33 46.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "132.74 46.55 132.99 46.69 67.28 160.49 66.73 160.17 132.33 46.55 132.74 46.55"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 34.71,
    y: 103.43,
    width: 131.4,
    height: 0.63,
    transform: "translate(-39.64 138.83) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 35.26,
    y: 103.75,
    width: 131.4,
    height: 0.63,
    transform: "translate(-39.64 139.46) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 35.81,
    y: 104.06,
    width: 131.4,
    height: 0.63,
    transform: "translate(-39.64 140.1) rotate(-60)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "134.63 47.64 149.7 56.34 149.7 165.93 76.71 165.93 68.93 161.44 134.63 47.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "50.1 4.84 7.89 77.94 7.89 4.84 50.1 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "50.83 4.84 7.89 79.21 7.89 77.94 50.1 4.84 50.83 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "51.57 4.84 7.89 80.48 7.89 79.21 50.83 4.84 51.57 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "52.3 4.84 7.89 81.75 7.89 80.48 51.57 4.84 52.3 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "53.03 4.84 7.89 83.02 7.89 81.75 52.3 4.84 53.03 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "53.77 4.84 7.89 84.29 7.89 83.02 53.03 4.84 53.77 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "54.5 4.84 7.89 85.56 7.89 84.29 53.77 4.84 54.5 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "55.23 4.84 7.89 86.83 7.89 85.56 54.5 4.84 55.23 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "55.97 4.84 7.89 88.1 7.89 86.83 55.23 4.84 55.97 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "56.7 4.84 7.89 89.37 7.89 88.1 55.97 4.84 56.7 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "57.43 4.84 7.89 90.64 7.89 89.37 56.7 4.84 57.43 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "58.16 4.84 7.89 91.91 7.89 90.64 57.43 4.84 58.16 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "58.9 4.84 7.89 93.18 7.89 91.91 58.16 4.84 58.9 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "59.63 4.84 7.89 94.45 7.89 93.18 58.9 4.84 59.63 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "60.36 4.84 7.89 95.72 7.89 94.45 59.63 4.84 60.36 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "61.1 4.84 7.89 96.99 7.89 95.72 60.36 4.84 61.1 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "61.83 4.84 7.89 98.26 7.89 96.99 61.1 4.84 61.83 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "62.56 4.84 7.89 99.53 7.89 98.26 61.83 4.84 62.56 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "63.3 4.84 7.89 100.8 7.89 99.53 62.56 4.84 63.3 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "64.03 4.84 7.89 102.07 7.89 100.8 63.3 4.84 64.03 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "64.76 4.84 7.89 103.34 7.89 102.07 64.03 4.84 64.76 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "65.5 4.84 7.89 104.61 7.89 103.34 64.76 4.84 65.5 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "66.23 4.84 7.89 105.88 7.89 104.61 65.5 4.84 66.23 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "66.96 4.84 7.89 107.15 7.89 105.88 66.23 4.84 66.96 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "67.7 4.84 7.89 108.42 7.89 107.15 66.96 4.84 67.7 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "68.43 4.84 7.89 109.69 7.89 108.42 67.7 4.84 68.43 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "69.16 4.84 7.89 110.96 7.89 109.69 68.43 4.84 69.16 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "69.9 4.84 7.89 112.23 7.89 110.96 69.16 4.84 69.9 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "70.63 4.84 7.89 113.5 7.89 112.23 69.9 4.84 70.63 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "71.36 4.84 7.89 114.77 7.89 113.5 70.63 4.84 71.36 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "72.1 4.84 7.89 116.04 7.89 114.77 71.36 4.84 72.1 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "72.83 4.84 7.89 117.31 7.89 116.04 72.1 4.84 72.83 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "73.56 4.84 7.89 118.58 7.89 117.31 72.83 4.84 73.56 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "74.3 4.84 7.89 119.85 7.89 118.58 73.56 4.84 74.3 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-105",
    points: "75.03 4.84 7.89 121.12 7.89 119.85 74.3 4.84 75.03 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-137",
    points: "75.76 4.84 7.89 122.39 7.89 121.12 75.03 4.84 75.76 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "76.49 4.84 7.89 123.66 7.89 122.39 75.76 4.84 76.49 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "77.23 4.84 7.89 124.93 7.89 123.66 76.49 4.84 77.23 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "77.96 4.84 7.89 126.2 7.89 124.93 77.23 4.84 77.96 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "78.69 4.84 7.89 127.47 7.89 126.2 77.96 4.84 78.69 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "79.43 4.84 7.89 128.74 7.89 127.47 78.69 4.84 79.43 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-104",
    points: "80.16 4.84 7.89 130.01 7.89 128.74 79.43 4.84 80.16 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "80.89 4.84 7.89 131.28 7.89 130.01 80.16 4.84 80.89 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "81.63 4.84 7.89 132.55 7.89 131.28 80.89 4.84 81.63 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "82.36 4.84 7.89 133.82 7.89 132.55 81.63 4.84 82.36 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-139",
    points: "83.09 4.84 7.89 135.09 7.89 133.82 82.36 4.84 83.09 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "83.83 4.84 7.89 136.36 7.89 135.09 83.09 4.84 83.83 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "84.56 4.84 7.89 137.63 7.89 136.36 83.83 4.84 84.56 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "85.29 4.84 7.89 138.9 7.89 137.63 84.56 4.84 85.29 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "86.03 4.84 7.89 140.17 7.89 138.9 85.29 4.84 86.03 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "86.76 4.84 7.89 141.44 7.89 140.17 86.03 4.84 86.76 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "87.49 4.84 7.89 142.71 7.89 141.44 86.76 4.84 87.49 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "88.23 4.84 7.89 143.98 7.89 142.71 87.49 4.84 88.23 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "88.96 4.84 7.89 145.25 7.89 143.98 88.23 4.84 88.96 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "89.69 4.84 7.89 146.52 7.89 145.25 88.96 4.84 89.69 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "90.43 4.84 7.89 147.79 7.89 146.52 89.69 4.84 90.43 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-126",
    points: "91.16 4.84 7.89 149.06 7.89 147.79 90.43 4.84 91.16 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-126",
    points: "91.89 4.84 7.89 150.33 7.89 149.06 91.16 4.84 91.89 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "92.63 4.84 7.89 151.6 7.89 150.33 91.89 4.84 92.63 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "93.36 4.84 7.89 152.87 7.89 151.6 92.63 4.84 93.36 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "94.09 4.84 7.89 154.14 7.89 152.87 93.36 4.84 94.09 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "94.82 4.84 7.89 155.41 7.89 154.14 94.09 4.84 94.82 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "95.56 4.84 7.89 156.68 7.89 155.41 94.82 4.84 95.56 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "96.29 4.84 7.89 157.95 7.89 156.68 95.56 4.84 96.29 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "97.02 4.84 7.89 159.22 7.89 157.95 96.29 4.84 97.02 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "97.76 4.84 7.89 160.49 7.89 159.22 97.02 4.84 97.76 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "98.49 4.84 7.89 161.76 7.89 160.49 97.76 4.84 98.49 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "99.22 4.84 7.89 163.03 7.89 161.76 98.49 4.84 99.22 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-142",
    points: "99.96 4.84 7.89 164.3 7.89 163.03 99.22 4.84 99.96 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "100.69 4.84 7.89 165.57 7.89 164.3 99.96 4.84 100.69 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "101.42 4.84 7.89 166.84 7.89 165.57 100.69 4.84 101.42 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "102.16 4.84 7.89 168.11 7.89 166.84 101.42 4.84 102.16 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "102.89 4.84 7.89 169.38 7.89 168.11 102.16 4.84 102.89 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "103.62 4.84 7.89 170.65 7.89 169.38 102.89 4.84 103.62 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "104.36 4.84 7.89 171.92 7.89 170.65 103.62 4.84 104.36 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "105.09 4.84 7.89 173.19 7.89 171.92 104.36 4.84 105.09 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-144",
    points: "105.82 4.84 7.89 174.46 7.89 173.19 105.09 4.84 105.82 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "106.56 4.84 7.89 175.73 7.89 174.46 105.82 4.84 106.56 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "107.29 4.84 7.89 177 7.89 175.73 106.56 4.84 107.29 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "108.02 4.84 7.89 178.27 7.89 177 107.29 4.84 108.02 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "108.76 4.84 7.89 179.54 7.89 178.27 108.02 4.84 108.76 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "109.49 4.84 7.89 180.81 7.89 179.54 108.76 4.84 109.49 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "110.22 4.84 7.89 182.08 7.89 180.81 109.49 4.84 110.22 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "110.96 4.84 7.89 183.35 7.89 182.08 110.22 4.84 110.96 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "111.69 4.84 7.97 184.49 7.89 184.45 7.89 183.35 110.96 4.84 111.69 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "112.42 4.84 8.52 184.81 7.97 184.49 111.69 4.84 112.42 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "113.16 4.84 9.07 185.12 8.52 184.81 112.42 4.84 113.16 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "113.89 4.84 9.62 185.44 9.07 185.12 113.16 4.84 113.89 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "114.62 4.84 10.17 185.76 9.62 185.44 113.89 4.84 114.62 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "115.35 4.84 10.72 186.07 10.17 185.76 114.62 4.84 115.35 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "116.09 4.84 11.27 186.39 10.72 186.07 115.35 4.84 116.09 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "116.82 4.84 11.82 186.71 11.27 186.39 116.09 4.84 116.82 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "117.55 4.84 12.37 187.03 11.82 186.71 116.82 4.84 117.55 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "118.29 4.84 12.92 187.34 12.37 187.03 117.55 4.84 118.29 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "119.02 4.84 13.47 187.66 12.92 187.34 118.29 4.84 119.02 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "119.75 4.84 14.02 187.98 13.47 187.66 119.02 4.84 119.75 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "120.49 4.84 14.57 188.3 14.02 187.98 119.75 4.84 120.49 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "121.22 4.84 15.12 188.61 14.57 188.3 120.49 4.84 121.22 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "121.95 4.84 15.67 188.93 15.12 188.61 121.22 4.84 121.95 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "122.69 4.84 16.22 189.25 15.67 188.93 121.95 4.84 122.69 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "123.42 4.84 16.77 189.57 16.22 189.25 122.69 4.84 123.42 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "124.15 4.84 17.32 189.88 16.77 189.57 123.42 4.84 124.15 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-116",
    points: "124.89 4.84 17.87 190.2 17.32 189.88 124.15 4.84 124.89 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "125.62 4.84 18.42 190.52 17.87 190.2 124.89 4.84 125.62 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "126.35 4.84 18.97 190.84 18.42 190.52 125.62 4.84 126.35 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "127.09 4.84 19.52 191.15 18.97 190.84 126.35 4.84 127.09 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-121",
    points: "127.82 4.84 20.07 191.47 19.52 191.15 127.09 4.84 127.82 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "128.55 4.84 20.62 191.79 20.07 191.47 127.82 4.84 128.55 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "129.29 4.84 21.17 192.11 20.62 191.79 128.55 4.84 129.29 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "130.02 4.84 21.72 192.42 21.17 192.11 129.29 4.84 130.02 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "130.75 4.84 22.27 192.74 21.72 192.42 130.02 4.84 130.75 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "131.49 4.84 22.81 193.06 22.27 192.74 130.75 4.84 131.49 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "132.22 4.84 23.36 193.38 22.81 193.06 131.49 4.84 132.22 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "132.95 4.84 23.91 193.69 23.36 193.38 132.22 4.84 132.95 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "133.68 4.84 24.46 194.01 23.91 193.69 132.95 4.84 133.68 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "134.42 4.84 25.01 194.33 24.46 194.01 133.68 4.84 134.42 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "135.15 4.84 25.56 194.65 25.01 194.33 134.42 4.84 135.15 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "135.88 4.84 26.11 194.96 25.56 194.65 135.15 4.84 135.88 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "136.62 4.84 26.66 195.28 26.11 194.96 135.88 4.84 136.62 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-143",
    points: "137.35 4.84 27.21 195.6 26.66 195.28 136.62 4.84 137.35 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-143",
    points: "138.08 4.84 27.76 195.92 27.21 195.6 137.35 4.84 138.08 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "138.82 4.84 28.31 196.23 27.76 195.92 138.08 4.84 138.82 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "139.55 4.84 28.86 196.55 28.31 196.23 138.82 4.84 139.55 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "140.28 4.84 29.41 196.87 28.86 196.55 139.55 4.84 140.28 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "141.02 4.84 29.96 197.19 29.41 196.87 140.28 4.84 141.02 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "141.75 4.84 30.51 197.5 29.96 197.19 141.02 4.84 141.75 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "142.48 4.84 31.06 197.82 30.51 197.5 141.75 4.84 142.48 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "143.22 4.84 31.61 198.14 31.06 197.82 142.48 4.84 143.22 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "143.95 4.84 32.16 198.46 31.61 198.14 143.22 4.84 143.95 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "144.68 4.84 32.71 198.77 32.16 198.46 143.95 4.84 144.68 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "145.42 4.84 33.26 199.09 32.71 198.77 144.68 4.84 145.42 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "146.15 4.84 33.81 199.41 33.26 199.09 145.42 4.84 146.15 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "146.88 4.84 34.36 199.73 33.81 199.41 146.15 4.84 146.88 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "147.62 4.84 34.91 200.04 34.36 199.73 146.88 4.84 147.62 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "148.35 4.84 35.46 200.36 34.91 200.04 147.62 4.84 148.35 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "149.08 4.84 36.01 200.68 35.46 200.36 148.35 4.84 149.08 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-114",
    points: "149.82 4.84 36.56 201 36.01 200.68 149.08 4.84 149.82 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-117",
    points: "150.55 4.84 37.11 201.31 36.56 201 149.82 4.84 150.55 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "151.28 4.84 37.66 201.63 37.11 201.31 150.55 4.84 151.28 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "152.01 4.84 38.21 201.95 37.66 201.63 151.28 4.84 152.01 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "152.75 4.84 38.76 202.27 38.21 201.95 152.01 4.84 152.75 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "153.48 4.84 39.31 202.58 38.76 202.27 152.75 4.84 153.48 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "154.21 4.84 39.86 202.9 39.31 202.58 153.48 4.84 154.21 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "154.95 4.84 40.41 203.22 39.86 202.9 154.21 4.84 154.95 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "155.68 4.84 40.96 203.54 40.41 203.22 154.95 4.84 155.68 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "156.41 4.84 41.51 203.85 40.96 203.54 155.68 4.84 156.41 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "157.15 4.84 42.06 204.17 41.51 203.85 156.41 4.84 157.15 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "157.88 4.84 42.61 204.49 42.06 204.17 157.15 4.84 157.88 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "158.61 4.84 43.16 204.81 42.61 204.49 157.88 4.84 158.61 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "159.35 4.84 43.71 205.12 43.16 204.81 158.61 4.84 159.35 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "161.38 4.84 201.56 28.03 201.56 134.54 159.36 207.64 48.07 207.64 43.71 205.12 159.35 4.84 161.38 4.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "159.36 207.64 201.56 134.54 201.56 207.64 159.36 207.64"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "85.42 171.5 57.48 219.89 113.36 219.89 85.42 171.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "141.3 171.5 113.36 219.89 169.24 219.89 141.3 171.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "113.36 219.89 141.3 171.5 85.42 171.5 113.36 219.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "169.24 219.89 197.17 171.5 141.3 171.5 169.24 219.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "57.48 219.89 85.42 171.5 29.54 171.5 57.48 219.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "141.3 171.6 169.24 123.21 113.36 123.21 141.3 171.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "197.5 171.6 225.44 123.21 169.56 123.21 197.5 171.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "85.42 171.6 113.36 123.21 57.48 123.21 85.42 171.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "57.48 123.31 85.42 74.92 29.54 74.92 57.48 123.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "1.6 123.31 29.54 74.92 -26.34 74.92 1.6 123.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "28.81 74.92 56.75 26.53 .87 26.53 28.81 74.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "29.54 171.6 57.48 123.21 1.6 123.21 29.54 171.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "29.54 74.92 1.6 123.31 57.48 123.31 29.54 74.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: ".87 26.53 -27.07 74.92 28.81 74.92 .87 26.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "197.5 74.92 169.56 123.31 225.44 123.31 197.5 74.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "113.36 123.21 85.42 171.6 141.3 171.6 113.36 123.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "57.48 123.21 29.54 171.6 85.42 171.6 57.48 123.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "169.24 123.21 141.3 171.6 197.17 171.6 169.24 123.21"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtlLogo);
export default __webpack_public_path__ + "static/media/otl-logo.4711475042dc8669993c3a1a0c808afd.svg";
export { ForwardRef as ReactComponent };